module.exports = __webpack_public_path__ + "assets/120ef850e6b6c697a3ce70b753a18b15.png";